import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined"
import Box from "@mui/material/Box"
import TableCell from "@mui/material/TableCell"
import TableSortLabel from "@mui/material/TableSortLabel"
import { styled } from "@mui/material/styles"
import { useState } from "react"

export const NoWrapTableCell = styled(TableCell)(({ theme }) => ({
  whiteSpace: "nowrap",
  paddingRight: theme.spacing(1.25),
  paddingBlock: theme.spacing(1.25),
  color: theme.palette.text.secondary,
  [theme.breakpoints.only("xs")]: {
    paddingBlock: theme.spacing(0.25),
    fontSize: "12px",
    "& .MuiButton-sizeSmall": {
      paddingBlock: "2px",
      paddingInline: "0px",
      fontSize: "11px",
    },
    "& .MuiChip-root": {
      fontSize: "11px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1rem",
    },
  },
}))

export const NumberTableCell = styled(NoWrapTableCell)(() => ({
  textAlign: "center",
}))

/**
 * Clips overflowing text with a CSS ellipsis rather than shortening the string,
 * so highlighting the cell still copies the untruncated value.
 */
export function TruncatedText({ children, maxWidth = 240, sx }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        maxWidth,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        verticalAlign: "bottom",
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export const HeaderTableCell = styled(NoWrapTableCell)(({ theme }) => ({
  textTransform: "uppercase",
  fontWeight: 600,
  color: theme.palette.text.primary,
  background: "#eae8ed",
  backdropFilter: "blur(21px)",
  [theme.breakpoints.only("xs")]: {
    paddingBlock: theme.spacing(0.75),
  },
}))

export function SortableHeaderCell({
  HeaderCellComponent = HeaderTableCell,
  label,
  columnName,
  sortColumn,
  sortDirection,
  onClick,
  props,
  children,
}) {
  const active = sortColumn === columnName
  const [isHovered, setIsHovered] = useState(false)
  return (
    <HeaderCellComponent
      sortDirection={active ? sortDirection : false}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <TableSortLabel
        active={true}
        direction={active ? sortDirection : "asc"}
        onClick={() => onClick(columnName)}
        IconComponent={
          isHovered || active ? ArrowDownwardIcon : StyledSwapVertIcon
        }
      >
        {label}
        {children}
      </TableSortLabel>
    </HeaderCellComponent>
  )
}

export const StickyHeaderTableCell = styled(HeaderTableCell)(({ theme }) => ({
  position: "sticky",
  left: 0,
  zIndex: 3,
  [theme.breakpoints.only("xs")]: {
    // position: "sticky",
  },
}))

export const StickyTableCell = styled(NoWrapTableCell)(({ theme }) => ({
  position: "sticky",
  left: 0,
  color: theme.palette.text.primary,
  fontWeight: 500,
  zIndex: 1,
  background:
    "linear-gradient(159deg, rgba(239, 235, 251, 0.9) 3.01%, rgba(243, 243, 250, 0.8) 103.3%)",
  backdropFilter: "blur(6px)",
  [theme.breakpoints.only("xs")]: {
    // position: "static",
  },
}))

const StyledSwapVertIcon = styled(SwapVertOutlinedIcon)(() => ({
  fillOpacity: 0.4,
}))
